import { ElMessage } from 'element-plus'

export function showErrorMessage(message: string): void {
  ElMessage({
    message,
    type: 'error',
  })
}

export function showWarnMessage(message: string): void {
  ElMessage({
    message,
    type: 'warning',
  })
}

export function showSuccessMessage(message: string): void {
  ElMessage({
    message,
    type: 'success',
  })
}
